import React, { useState, useContext } from "react";
import icon__close from "../../../asset/icon/close-icon.svg";
import * as userApi from "../../../service/userApi";
import CheckBoxV2 from "../checkboxV2/CheckBoxV2";

import { CurrentUserContext } from "../../../App";

function ModalCreate({
  titlename,
  onClose,
  placeholder,
  placeholderTextArea,
  btnsubmitname,
  showBtnCancle,
  showIconClose,
  limitSizeHeight,
  limitSizeWeight,
  type, //ไว้กำหนดอนยิว api
}) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [valueInput, setValueInput] = useState("");
  const [valueTextArea, setValueTextArea] = useState("");
  const [showName, setShowName] = useState(true);
  const handleChangeValueInput = (e) => {
    setValueInput(e.target.value);
  };

  const handleChangeValueTextArea = (e) => {
    setValueTextArea(e.target.value);
  };
  // console.log(showName)
  const postApiCreateKratu = async (valueTitle, valueDetail, show_name) => {
    // console.log("1")
    let res = "";
    res = await userApi.addKratu(valueTitle, valueDetail, show_name);
    // console.log("2")
    if (res) {
      if (res?.data?.code === 200) {
        setIsMessage({ type: "success", data: "สร้างกระทู้เเล้ว" });
        onClose();
      } else {
        setIsMessage({
          type: "warning",
          data: res?.data?.message_th || res?.data?.message,
        });
      }
    } else {
      setIsMessage({ type: "error", data: "สร้างกระทู้ไม่สำเร็จ" });
    }
  };

  const onClickSubmitSave = (valueTitle, valueDetail) => {
    if (valueTitle === "") {
      setIsMessage("กรุณาใส่ระบุหัวข้อกระทู้");
      return;
    }
    if (valueDetail === "") {
      setIsMessage("กรุณาใส่รายละเอียด");
      return;
    } else {
      postApiCreateKratu(valueInput, valueTextArea, showName);
    }
  };

  return (
    <div className="fixed w-full h-full z-20 inset-0 flex justify-center items-center bg-[#0000008f]">
      <div
        className={`sm:w-[400px] ${limitSizeWeight ? limitSizeWeight : "w-[600px]"}] h-[${limitSizeHeight ? limitSizeHeight : "h-[500px]"}] bg-[#FFFFFF] rounded-3xl`}
      >
        {showIconClose ? (
          <>
            <div className="flex justify-end my-[5px]">
              <img
                onClick={() => {
                  onClose();
                }}
                className="w-[30px] h-[30px] mr-[30px] hover:cursor-pointer"
                src={icon__close}
                alt=""
              />
            </div>
          </>
        ) : null}
        <div className="mt-[20px] px-[30px] pb-[30px]">
          <div className="text-[20px] font-bold text-center text-[#2E2E2E]">
            {titlename}
          </div>
          <div className="my-[45px]"></div>
          <input
            className="border-[2px] border-solid border-[#A2B5BC] rounded-xl text=state-100 text-[#A2B5BC] p-5 focus:outline-none mt-1 mb-4 h-[30px] w-full"
            placeholder={placeholder}
            onChange={(e) => {
              handleChangeValueInput(e);
            }}
            value={valueInput}
          ></input>

          <textarea
            className="border-2 border-solid border-[#A2B5BC] rounded-xl text=state-100 text-[#A2B5BC] p-5 focus:outline-none mt-1 w-full h-40"
            placeholder={placeholderTextArea}
            onChange={(e) => {
              handleChangeValueTextArea(e);
            }}
            value={valueTextArea}
          ></textarea>

          <div className="flex justify-end items-center gap-[10px] my-[5px]">
            <div>
              <CheckBoxV2 id="1" value={showName} setValue={setShowName} />
            </div>
            <div>แสดงชื่อผู้ใช้งานของฉัน</div>
          </div>

          <div className="flex justify-center my-6 gap-[20px]">
            <button
              className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
              onClick={() => {
                onClickSubmitSave(valueInput, valueTextArea);
              }}
            >
              {btnsubmitname}
            </button>
            {showBtnCancle ? (
              <>
                <button
                  onClick={() => {
                    onClose();
                  }}
                  className="button-theme-pg flex justify-center items-center w-48 h-10 border-[1px] border-solid border-[#85DDDE] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
                >
                  ยกเลิก
                </button>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalCreate;
